import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import renderSelectField from "../../../../../../shared/components/form/Select";
import * as configs from "../../../../Products/ProductsListing/config";
import * as products from "../../../../../../shared/service/products";
import ReactTags from "react-tag-autocomplete";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    type: "Premium",
    name: "",
    cost: "",
    valid: "",
    usage: "",
    website: "",
    startDate: "",
    concurrentConnection: products.concurrentConnections,
    contracts: products.contracts,
    subnet_suggestions: [],
    subnets: [],
    noOfProxies: 0,
    proxies: [],
    proxiesUpdated: false,
    tags: [],
    bandwidth: "",
    domains: "",
    description: "",
    notes: "",
  };

  componentDidMount() {
    if (this.props.edit.product_id !== undefined) {
      let product = this.props.edit;
      if (product.proxies === null) {
        product.proxies = [];
      }

      this.props.initialize(product);
      this.setState(product, () => {
        this.props.handleForm(this.state);
      });
    } else {
      this.props.initialize(this.state);
      this.props.handleForm(this.state);
    }

    this.useCaseRef = React.createRef();
    this.tagRef = React.createRef();
  }

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  getLocations = () => {
    let locations = [];
    this.props.subnets.forEach((subnet) => {
      let location = locations.filter(
        (obj) => obj.value === subnet.geo_maxmind
      );

      if (location.length === 0) {
        locations.push({
          value: subnet.geo_maxmind,
          label: subnet.geo_maxmind,
        });
      }
    });
    locations.sort(function(a, b) {
      var x = a["value"];
      var y = b["value"];
      return x < y ? -1 : x > y ? 1 : 0;
    });

    return locations;
  };

  filterSubnets = (event) => {
    let filteredSubnets = this.props.subnets.filter(
      (obj) => event.value === obj.geo_maxmind
    );

    let useCase = this.props.usages.filter(
      (obj) => this.state.usage === obj.slug
    );

    if (useCase.length) {
      useCase = useCase[0];

      let useCasefilteredSubnets = filteredSubnets.filter((obj) => {
        let returnValue = obj.use_cases.filter(
          (uObj) => uObj.id === useCase.id
        );
        return returnValue.length > 0 ? true : false;
      });

      filteredSubnets = useCasefilteredSubnets;
    }

    let website = this.props.websites.filter(
      (obj) => this.state.website === obj.id
    );

    if (website.length) {
      website = website[0];

      let websiteFilteredSubnets = filteredSubnets.filter((obj) => {
        let returnValue = obj.websites.filter((wObj) => wObj.id === website.id);
        return returnValue.length > 0 ? true : false;
      });

      filteredSubnets = websiteFilteredSubnets;
    }

    let subnets = [];
    filteredSubnets.forEach((subnet) => {
      subnets.push({
        slug: subnet.sid,
        name: subnet.subnet,
      });
    });

    this.setState({ subnet_suggestions: subnets, subnets: [] });
  };

  onDelete(i) {
    const subnets = this.state.subnets.slice(0);
    subnets.splice(i, 1);
    this.setState({ subnets }, () => {
      this.props.handleForm(this.state);
    });
  }

  onAddition(subnet) {
    const subnets = [].concat(this.state.subnets, subnet);
    this.setState({ subnets }, () => {
      this.props.handleForm(this.state);
    });
  }

  removeProxy = (proxy) => {
    this.setState(
      {
        proxies: this.state.proxies.filter((obj) => proxy.sid !== obj.sid),
        proxiesUpdated: true,
      },
      () => {
        this.props.handleForm(this.state);
      }
    );
  };

  addProxies = () => {
    let proxies = this.state.proxies;

    if (this.state.subnets.length > 0 && this.state.noOfProxies > 0) {
      let subnets = this.state.subnets;

      let mod = parseInt(
        parseInt(this.state.noOfProxies) % this.state.subnets.length
      );

      subnets.map((subnet) => {
        let subnetObj = this.props.subnets.filter(
          (obj) => subnet.name === obj.subnet
        );

        if (subnetObj.length > 0) {
          Object.keys(subnetObj[0]).forEach(function(key) {
            subnet[key] = subnetObj[0][key];
          });
        }

        subnet["no"] =
          parseInt(
            parseInt(this.state.noOfProxies) / this.state.subnets.length
          ) + mod;

        mod = 0;

        return subnet;
      });

      let errors = [];

      subnets.forEach((subnet) => {
        let availableProxies = 0;
        if (
          typeof subnet.proxies !== undefined &&
          typeof subnet.proxies.available_proxies !== undefined
        ) {
          availableProxies = subnet.proxies.available_proxies;
        }

        if (subnet.no > availableProxies) {
          errors.push(
            subnet.name +
              " does not have sufficent proxies. ( Required Proxies : " +
              subnet.no +
              ", Available proxies : " +
              availableProxies +
              ")"
          );
        }
      });

      if (errors.length > 0) {
        this.props.showError(errors);
        return false;
      }

      subnets.forEach((subnet) => {
        proxies.push({
          sid: subnet.sid,
          subnet: subnet.subnet,
          lid: subnet.lid,
          no: subnet.no,
          location: subnet.geo_maxmind,
        });
      });

      this.setState(
        {
          proxies: proxies,
          subnets: [],
          noOfProxies: 0,
          proxiesUpdated: true,
          location: "",
        },
        () => {
          //      this.props.initialize(this.state);
          this.props.handleForm(this.state);
          this.props.initialize(this.state);
        }
      );
    } else {
      this.props.showError(["Please select subnet(s) and number of proxies."]);
    }
  };

  getOptions = (key) => {
    switch (key) {
      case "concurrent_connection":
        return this.state.concurrentConnection;
      case "contract":
        console.log("key", key);
        return this.state.contracts;
      case "usage":
        let usages = [];
        this.props.usages.forEach((usage, index) => {
          usages.push({ value: usage.slug, label: usage.name });
        });
        return usages;
      case "website":
        let websites = [];
        this.props.websites.forEach((website) => {
          websites.push({ value: website.id, label: website.name });
        });
        return websites;
      case "type":
        let packages = [];
        packages.push({
          value: "Private",
          label: "Custom Private Proxies",
        });

        packages.push({
          value: "Premium",
          label: "Custom Premium Proxies",
        });

        this.props.products.forEach((product, index) => {
          packages.push({
            value: product.id,
            label: `${product.number} ${product.name} Proxies`,
          });
        });
        return packages;
      default:
        return [];
    }
  };

  setStartDate = (startDate) => {
    this.setState({ startDate: startDate }, () => {
      let days = parseInt(startDate.diff(new Date(), "days")) + 2;

      this.setState({ valid: days }, () => {
        this.props.handleForm(this.state);
      });
    });
  };

  setValidDays = (event) => {
    this.setState({ valid: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  printInput = (input) => {
    switch (input.key) {
      case "valid":
        return (
          <>
            <DatePicker
              dateFormat="DD-MM-YYYY"
              selected={
                this.state.startDate
                  ? moment(this.state.startDate, "DD-MM-YYYY")
                  : moment()
              }
              onChange={(date) => this.setStartDate(date)}
            />
            {/* <Field
              name={input.key}
              component={renderSelectField}
              options={products.getValidDays}
              onChange={this.setValidDays}
            /> */}
          </>
        );
      case "concurrent_connection":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
            onChange={this.formConnectionHandler}
          />
        );
      case "contract":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
            onChange={this.formConnectionHandlerUsage}
          />
        );
      case "usage":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
            onChange={this.formConnectionHandlerUsage}
          />
        );
      case "website":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
            onChange={this.formConnectionHandlerWebsite}
          />
        );
      case "type":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
            onChange={this.formConnectionHandlerType}
          />
        );
      case "description":
      case "domains":
      case "notes":
        return (
          <Field
            component="textarea"
            type="textarea"
            name={input.key}
            options={this.getOptions(input.key)}
            onChange={this.formChangeHandler}
          />
        );

      default:
        return (
          <Field
            name={input.key}
            component="input"
            type={input.type}
            placeholder={input.name}
            onKeyUp={this.formChangeHandler}
          />
        );
    }
  };

  formConnectionHandlerType = (event) => {
    if (event.value !== "custom") {
      this.props.products.forEach((product) => {
        if (event.value === product.id) {
          this.setState(
            {
              api: product.api,
              cost: product.cost,
              id: product.id,
              name: product.name,
              proxies: product.proxies,
              type: product.type,
              valid: product.valid,
              website: product.website,
            },
            () => {
              this.props.initialize(this.state);
              this.props.handleForm(this.state);
            }
          );
        }
      });
    }

    this.setState({ type: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formConnectionHandlerWebsite = (event) => {
    if (this.props.edit.product_id !== undefined) {
      this.setState({ website: event.value, location: "" }, () => {
        this.props.handleForm(this.state);
        this.props.initialize(this.state);
      });
    } else {
      this.setState({ website: event.value, proxies: [], location: "" }, () => {
        this.props.handleForm(this.state);
        this.props.initialize(this.state);
      });
    }
  };

  formConnectionHandlerUsage = (event) => {
    if (this.props.edit.product_id !== undefined) {
      this.setState({ usage: event.value, location: "" }, () => {
        this.props.handleForm(this.state);
        this.props.initialize(this.state);
      });
    } else {
      this.setState({ usage: event.value, proxies: [], location: "" }, () => {
        this.props.handleForm(this.state);
        this.props.initialize(this.state);
      });
    }
  };

  formConnectionHandler = (event) => {
    this.setState({ concurrent_connection: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formLocationHandler = (event) => {
    this.setState({ proxyLocation: event });
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  proxiesChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {});
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">
            {this.state.product_id !== undefined ? (
              <React.Fragment>Edit Product - {this.state.name}</React.Fragment>
            ) : (
              this.props.title
            )}
          </h5>
        </div>
        <form
          autoComplete="off"
          className="form form--horizontal"
          onSubmit={handleSubmit}
        >
          {configs.columnHeader.map(
            (input) =>
              ((input.canAdd && this.state.product_id === undefined) ||
                (input.canEdit && this.state.product_id !== undefined)) &&
              (!input.key.includes("residential") ||
                (input.key.includes("residential") &&
                  this.state.name.toLowerCase().includes("residential"))) && (
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {input.name}
                    {input.key === "cost" ? (
                      <React.Fragment>
                        <br />
                        <small>(use 0 for test proxies)</small>
                      </React.Fragment>
                    ) : (
                      ""
                    )}
                  </span>
                  <div className="form__form-group-field">
                    {this.printInput(input)}
                  </div>
                </div>
              )
          )}
          {this.state.product_id === undefined ? (
            <React.Fragment>
              <div className="form__form-group">
                <div className="form__form-group-label col-sm-3 col-md-3">
                  Location
                </div>
                <div className="form__form-group-label col-sm-3 col-md-3">
                  Subnets
                </div>
                <div className="form__form-group-field col-sm-3 col-md-3">
                  Proxies
                </div>
              </div>
              <div className="form__form-group">
                <div className="col-sm-3 col-md-3">
                  <Field
                    name="location"
                    component={renderSelectField}
                    options={this.getLocations()}
                    onChange={this.filterSubnets}
                  />
                </div>
                <div className="col-sm-3 col-md-3">
                  <ReactTags
                    ref={this.inputRef}
                    tags={this.state.subnets}
                    allowNew="false"
                    suggestions={this.state.subnet_suggestions}
                    onDelete={this.onDelete.bind(this)}
                    onAddition={this.onAddition.bind(this)}
                    placeholderText="Add location"
                    addOnBlur="true"
                    minQueryLength="1"
                  />
                </div>
                <div className="col-sm-3 col-md-3">
                  <Field
                    name="noOfProxies"
                    component="input"
                    type="number"
                    placeholder="No of proxies"
                    min="1"
                    onKeyUp={this.formChangeHandler}
                  />
                </div>
                <div className="col-sm-3 col-md-3 successParentDiv">
                  <span
                    className="lnr lnr-plus-circle"
                    title="Add"
                    onClick={this.addProxies}
                  ></span>
                </div>
              </div>
              {this.state.proxies.map((proxy) => (
                <div className="form__form-group">
                  <div className="col-sm-3 col-md-3">{proxy.location}</div>
                  <div className="col-sm-3 col-md-3">{proxy.subnet}</div>
                  <div className="col-sm-3 col-md-3">{proxy.no}</div>
                  <div className="col-sm-3 col-md-3 trashParentDiv">
                    <span
                      className="lnr lnr-trash"
                      title="Remove"
                      onClick={() => this.removeProxy(proxy)}
                    ></span>
                  </div>
                </div>
              ))}
            </React.Fragment>
          ) : (
            ""
          )}
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "assign_product_form", // a unique identifier for this form
})(HorizontalForm);
